import { Pagination, Sort } from "@saleor/types";
import { stringifyQs } from "@saleor/utils/urls";

export enum ExporOrderListSortField {
  soNo = "soNo",
  poNo = "poNo",
  contractNo = "contractNo",
  createDate = "createDate"
}

export enum ChangeOrderSortField {
  material_code = "material_code"
}

export const inquirySearchOrderUrl = "/inquiry-search-order";

export type ExporOrderListUrlSort = Sort<ExporOrderListSortField>;
export type ExporOrderListUrlQueryParams = Pagination & ExporOrderListUrlSort;

export type ChangeOrderUrlSort = Sort<ChangeOrderSortField>;
export type ChangeOrderQueryParams = Pagination & ChangeOrderUrlSort;

export const exporOrderListUrl = (params?: ExporOrderListUrlQueryParams) =>
  inquirySearchOrderUrl + "?" + stringifyQs(params);

export interface OrderProcessingParams {
  callback?: string;
}
